<template>
  <div>
    <el-form :inline="true" style="margin:20px 0 0">
      <el-form-item>
        <el-button size="medium" style="margin-left: 20px" @click="addPrice">新增</el-button>
      </el-form-item>
    </el-form>
    <div style="background:white;border-radius:3px">
      <el-table :data="tableData" style="width: 100%" border stripe>
        <el-table-column prop="index" label="序号" width="80" type="index"></el-table-column>
        <el-table-column prop="PRICE_INTERVAL" label="价格区间"></el-table-column>
        <el-table-column prop="POINT" label="加点"></el-table-column>
        <el-table-column prop="action" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editName(scope.row)">修改加点</el-button>
            <el-button type="text" size="small" @click="deleteName(scope.row)">删除</el-button>
            <!-- <el-button type="text" size="small" @click="exportTable(scope.row)">导出</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增 -->
    <el-dialog :visible.sync="addDialog" @close="addDialog = false" title="新增特殊产品加点" width="400px" center>
      <el-form ref="addForm" v-model="addForm" :inline="true">
        <el-form-item label="加点级别：" :label-width="formLableWidth">
          <el-input v-model="addForm.ADD_POINT"></el-input>
        </el-form-item>
        <el-form-item label="价格区间：" :label-width="formLableWidth">
          <el-input v-model="addForm.MIN_PRICE" style="width:100px"></el-input>-
          <el-input v-model="addForm.MAX_PRICE" style="width:100px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="addDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitAddPrice">确认</el-button>
      </div>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog :visible.sync="editDialog" @close="editDialog = false" title="修改特殊产品加点" width="400px" center>
      <el-form ref="editForm" v-model="editForm" :inline="true">
        <el-form-item label="加点级别：" :label-width="formLableWidth">
          <el-input v-model="editForm.POINT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="editDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitEditPrice">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      formLableWidth: '100px',
      addForm: {
        product: '',
        POINT: '',
        PRODUCT_CODE: '',
      },
      product: [],
      addDialog: false,
      // 修改模态框
      editDialog: false,
      editForm: {},
      GYS_ID: Number(sessionStorage.getItem('tcId')),
      CATALOG_CODE: this.$route.params.CATALOG_CODE,
      SCHEME_ID: sessionStorage.getItem('priceAddPoint-SCHEME_ID'),

    };
  },
  created() {
    this.queryProductCatalog();
  },
  methods: {
    //   拉取产品信息
    queryProductCatalog() {
      const param = {
        SERVICE_ID: '10023',
        OTYPE: 20,
        GYS_ID: this.GYS_ID,
        SCHEME_ID: this.SCHEME_ID,
        CATALOG_CODE: this.CATALOG_CODE,
        PAGE_SIZE: 100000000,
        PAGE_INDEX: 0,
      };
      http
        .post(param)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].SPECIAL_INTERVAL_LIST;
          } else {
            this.tableData = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 新增大类名称
    submitAddPrice() {
      if (!this.addForm.ADD_POINT || !this.addForm.MIN_PRICE || !this.addForm.MAX_PRICE) {
        this.$message.show({ text: '请输入加点级别和加点区间', type: 'warning' });
        return false;
      }
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(this.addForm.ADD_POINT) || !reg.test(this.addForm.MIN_PRICE) || !reg.test(this.addForm.MAX_PRICE)) {
        this.$message.show({ text: '请输入正数的加点级别和加点区间', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 19,
        GYS_ID: this.GYS_ID,
        SCHEME_ID: this.SCHEME_ID,
        CATALOG_CODE: this.CATALOG_CODE,
        POINT: this.addForm.ADD_POINT,
        MIN_PRICE: this.addForm.MIN_PRICE,
        MAX_PRICE: this.addForm.MAX_PRICE,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addDialog = false;
        this.addForm = {};
        this.queryProductCatalog();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 修改大类名称
    editName(row) {
      // console.log(row);
      this.editDialog = true;
      this.editForm = row;
    },
    // 提交修改模态框
    submitEditPrice() {
      if (!this.editForm.POINT) {
        this.$message.show({ text: '请输入加点级别', type: 'warning' });
        return false;
      }
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(this.editForm.POINT)) {
        this.$message.show({ text: '请输入正数的加点级别', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 21,
        SPECIAL_INTERVAL_ID: this.editForm.SPECIAL_INTERVAL_ID,
        POINT: this.editForm.POINT,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.editDialog = false;
        this.queryProductCatalog();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 删除大类名称
    deleteName(row) {
      // console.log(row);
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 22,
        SPECIAL_INTERVAL_ID: row.SPECIAL_INTERVAL_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryProductCatalog();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addPrice() {
      this.addDialog = true;
    },
  },

};
</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/priceRangePlus.vue